import { ErrorResponse } from '@src/interface/api/response.interface'
import { uploadFile, UploadFileResponse } from '@src/lib/api/file/uploadFile'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'

const useUploadFile = (): UseMutationResult<
	UploadFileResponse,
	AxiosError<ErrorResponse>,
	FormData
> => {
	return useMutation((formData) => uploadFile(formData))
}

export default useUploadFile
